<template>
  <v-row class="pa-2" no-gutters>
    <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
    </v-col>

    <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

    <v-col
      class="pa-2 sticky-md"
      cols="12"
      md="4"
      style="top: 110px; height: fit-content"
    >
      <v-tabs-items
        v-model="qrShow"
        class="overflow-visible mb-4 mb-md-0"
        touchless
      >
        <v-tab-item>
          <qr-maker :loading="loading" :svg="svgMade" />
          <v-btn class="btn-download" @click="showDialog = true">
            <v-icon>mdi-progress-download</v-icon>
            {{ $t("download_qr") }}          </v-btn>
        </v-tab-item>

        <v-tab-item>
          <view-shop v-model="cardTexts" :loading="loading || qrLoading" />
        </v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-col class="pa-2 px-0" cols="12" md="8">
      <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
        <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
          <div class="row justify-center">
            <div class="col-md-12">
              <p>وارد کردن اطلاعات صفحه کاری</p>
            </div>
            <div class="col-md-6 mt-0 pt-0">
              <v-text-field
                v-model="cardTexts.visitName"
                :disabled="e6 > 2"
                append-icon="mdi-pen"
                class="mt-0 pt-0"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="نام صفحه کاری شما"
                outlined
              />
            </div>
          </div>
        </v-stepper-step>
        <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
          <list-expansion
            v-model="cardTexts"
            :components="specialInfo"
            :data="cardTexts"
            flat
          />

          <div class="col-md-12">
            <next-btn
              :loading="loading"
              style="background: #1b8d39"
              @click="markQr(true)"
              v-text="'ثبت و ذخیره'"
            />
          </div>
        </v-stepper-content>
      </v-stepper>
    </v-col>

    <custom-popup
      v-model="showDialog"
      :cons="cons"
      hide-confirm
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <v-card class="px-5">
        <download-file
          v-if="showDialog"
          :data="{ theme: '', data: cardTexts }"
          :svg="svgMade"
          :visit-name="cardTexts.visitName"
        />
      </v-card>
    </custom-popup>
  </v-row>
</template>

<script>
import { Bus, debounce } from "@/main";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import DownloadFile from "@/view/pages/qrland/downloadFile";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop";
import Counter from "@/view/components/Counter";
import Personnel from "@/view/components/Personnel";
import WorkSheet from "@/view/components/WorkSheet";
import Product from "@/view/components/Product/index";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "editSimplePage",
  props: {
    id: { type: String, default: "" },
  },
  components: {
    Counter,
    ViewShop,
    Personnel,
    WorkSheet,
    DownloadFile,
    QrMaker,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
  },

  data() {
    return {
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      qrLoading: false, 
      showDialog: false,
      specialInfo: [
        { name: "bannerSelector", value: "", title: "آپلود بنر", subtitle: "", icon: "image-area", model: "banner" },
        { name: "Service", value: "", title: "خدمات", subtitle: "", icon: "toolbox-outline" },
        { name: "Faq", value: "", title: "سوالات متداول", subtitle: "", icon: "help", model: "faq" },
        { name: "Blog", value: "", title: "بلاگ", subtitle: "", icon: "text" },
        { name: "Product", value: "", title: "ایجاد محصول", subtitle: "", icon: "sign-yield", model: "Product" },
        { name: "textCards", value: "", title: "اطلاعات کاربری", subtitle: "", icon: "account-outline" },
        { name: "socialMediaIcons", value: "", title: "افزودن شبکه های اجتماعی", subtitle: "", icon: "instagram", model: "socialMedia" },
      ],
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: "",
      cardTexts: {},
      res: {},
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  mounted() {
    this.fetchData();
    Bus.$on("socialMedias", (value) => {
      this.$set(this.cardTexts, "socialMedia", value);
    });
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    
    fixData(input) {
      if (!input || typeof input !== "object") input = {};

      if (!input.banner) input.banner = { gallery: null };
      if (!input.pdf) input.pdf = null;
      if (!input.gallery || input.gallery.length === 0) input.gallery = [{ name: "گالری عکس", images: [] }];
      if (!input.video_gallery) input.video_gallery = null;      
      if (!input.consultationNew) {
        input.consultationNew = {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        };
      } else if (!input.consultationNew.sectionColor) {
         input.consultationNew.sectionColor = { backGround: "", text: "" };
      }

      if (!input.service) {
        input.service = [
          { title: "پست 1", content: "", gallery: [{ name: "", images: [] }], color: null, icon: null },
        ];
      }
      if (!!input.pdfSelector && !input.pdfSelector.layout) {
        input.pdfSelector = { ...input.pdfSelector, layout: "list" };
      }
      if (!input.blog) {
        input.blog = [
          { title: "پست 1", content: "", gallery: [{ name: "", images: [] }], color: null, icon: null },
        ];
      }
      
      return input;
    },

    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "simpleBpage",
        qrType: "dynamic",
        title: this.res.title || this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({ theme: "", data: this.cardTexts }),
        qr: {
          section: "#link", link: "https://qr2.in/", backcolor: "#ffffff", frontcolor: "#000000", gradient_color: "#000000", marker_out_color: "#000000", marker_in_color: "#000000", marker_top_right_outline: "#000000", marker_top_right_center: "#000000", marker_bottom_left_outline: "#000000", marker_bottom_left_center: "#000000", framecolor: "#000000", optionlogo: "none", "logo-size": 100, marker: "default", marker_in: "default", outer_frame: "none", framelabel: "SCAN ME", label_font: "AbrilFatface.svg", "label-text-size": 100, size: "248", level: "M",
        },
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "simpleBpage",
          title: this.res.title || this.cardTexts.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.$toast.success("صفحه کاری شما با موفقیت ویرایش شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.errors = response.data.errors || {};
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchData() {
      this.loading = true;
      this.qrLoading = true;
      
      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          let parsedData =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;

          let info = parsedData; 
          this.setCreatedQrID(data.data.id);
          this.res = data.data;
          
          let rawData = info.data ? info.data : info;
          this.cardTexts = this.fixData(rawData);
        })
        .finally(() => {
          this.loading = false;
          this.qrLoading = false;
        });
    },
  },
};
</script>
